import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { syncMswForceFlag } from './mswForceFlag'
import { mswEnabled } from './toggles'

/**
 * Keeps MSW scenario flags in sync on client-side navigations (Auth0 return, stepper, etc.).
 */
const MswForceFlagSync = () => {
  const location = useLocation()

  useLayoutEffect(() => {
    if (mswEnabled()) {
      syncMswForceFlag()
    }
  }, [location.pathname, location.search])

  return null
}

export default MswForceFlagSync
